// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/medical-privacy-with-background.svg';

export const MedicalPrivacyWithBackground = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
